<template>
  <div id="Contact">
    <div class="banner">
      <img src="/static/images/contact/cs_bg.png" alt="">
      <div class="bannerText">
        <div class="title">{{$t("contact.bannerText")}}</div>
        <div class="titleSub">{{$t("contact.bannerDetail")}}</div>
      </div>
    </div>
    <div class="content">
        <div class="con">
            <div class="contactInfo">
              <div class="contactNumber">
                  <div class="title">
                    {{$t("contact.contactNumber.tit")}}
                  </div>
                  <div class="tel">
                    {{$t("contact.contactNumber.cnTel")}}
                  </div>
                  <div class="tel">
                    {{$t("contact.contactNumber.EnTel")}}
                  </div>
              </div>
              <div class="contactAddress">
                <div class="title">
                 {{$t("contact.contactAddress.tit")}}
                </div>
                <div class="address">
                  {{$t("contact.contactAddress.address1")}}
                </div>
                <div class="address">
                  {{$t("contact.contactAddress.address2")}}
                </div>
              </div>
              <div class="contactWechat">
                <div class="title">
                  {{$t("contact.contactWechat")}}
                </div>
                <div class="qrcode">
                  <img src="/static/images/common/qrcode.png" alt="">
                </div>
              </div>
            </div>
            <div class="contactUs">
                <div class="title">
                  {{$t("contact.contactUs.tit")}}
                </div>
                <div class="tips">
                  {{$t("contact.contactUs.tips")}}
                </div>
                <div class="inputBox">
                  <div class="first">
                    <el-input v-model="name" placeholder="Your Name"></el-input>
                    <el-input v-model="tel" placeholder="Your Moble"></el-input>
                    <el-input v-model="shopName" placeholder="Your Shop Name"></el-input>
                  </div>
                  <div class="second">
                    <el-input v-model="storType" placeholder="Your store type"></el-input>
                    <el-input v-model="storeAddress" placeholder="Your Shop Address"></el-input>
                  </div>
                </div>
                <div  class="submitBtn">
                  <el-button round>{{$t("contact.contactUs.submitBtn")}}</el-button>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name:'',
      tel:'',
      shopName:'',
      storType:'',
      storeAddress:''
    };
  },
  //定义这个sweiper对象
  computed: {},
  created:function () {
    window.scroll(0, 0);
    this.$emit('menuHiddens');
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    if (this.$getCookie("langs") == "en") {
      this.lang_en = true;
    } else {
      this.lang_en = false;
    }
    this.show=true
  },
  methods: {

  }
};
</script>
<style lang="less" type="text/less">
  .el-input__inner{
    background: #f7f7f7;
    color: #999
  }
  .el-input__inner:focus{
    border-color: #27C2B4;
  }
</style>
<style scoped lang="less" type="text/less">
#Contact{
  margin-top: 65px;
  .banner{
    position: relative;
    img{
      width: 100%;
    }
    .bannerText{
      position:absolute;
      top: 40%;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      .title{
        font-size: 40px;
        font-weight: bold;
        position: relative;
        padding-right: 40px;
        &::before{
          content:'';
          display: inline-block;
          height: 38px;
          width: 3px;
          background: #e2e2e2;
          position: absolute;
          right: 0;
          bottom: 7px;
        }
      }
      .titleSub{
        padding-left: 30px;
        font-size: 20px;
        max-width: 600px;
      }
    }
  }
  .content{
    padding: 60px 0;
    .con{
      width: 60%;
      margin: 0 auto;
      .contactInfo{
        display: flex;
        justify-content: space-between;
        align-items:flex-start;
        position: relative;
        &::before{
          content:'';
          display: inline-block;
          height: 1px;
          width: 100%;
          background: #e2e2e2;
          position: absolute;
          bottom: -35px;
        }
        .contactNumber{
          width: 40%;
          .title{
            font-size: 22px;
            color: #333;
            font-weight: bold;
          }
          .tel{
            font-size: 20px;
            color: #FF9703;
            font-weight: bold;
            padding: 15px 0;
            &:nth-child(3){
              padding-top: 0;
            }
          }
          .serviceTime{
            font-size: 14px;
            color: #666;
          }
        }
        .contactAddress{
          width: 40%;
          padding: 0 20px;
          .title{
            font-size: 22px;
            color: #333;
            font-weight: bold;
          }
          .address{
            font-size: 14px;
            color: #666;
            padding: 15px 0px;
            max-width: 500px;
            &:nth-child(3){
              padding-top: 0;
            }
          }
        }
        .contactWechat{
          width: 20%;
          padding-left: 20px;
          // text-align: center;
          .title{
            font-size: 22px;
            color: #333;
            font-weight: bold;
          }
          .qrcode{
            padding: 15px 0;
            img{
              width: 100%;
              max-width: 130px;
            }
          }
        }
      }
      .contactUs{
        padding: 60px 0;
        .title{
          color: #333;
          font-size: 22px;
          font-weight: bold;
        }
        .tips{
          color: #666;
          font-size: 14px;
          padding-top: 15px;
        }
        .inputBox{
          padding: 50px 0;
          .first{
            .el-input{
              display: inline-block;
              width: 32.2%;
              &:nth-child(2){
                margin: 0 1%;
              }
            }
          }
          .second{
            padding: 30px 0;
            .el-input{
              width: 65.8%;
              &:nth-child(1){
                width: 32.2%;
                margin-right: 1%;
              }
            }
          }
        }
          .submitBtn{
            text-align: center;
            button{
              background: #27C2B4;
              box-shadow:0px 3px 6px rgba(11,128,117,0.26);
              font-weight: bold;
              font-size: 16px;
              border-radius:38px;
              padding: 15px 35px;
              color: #fff;
              &:focus{
                border-color: #27C2B4;
              }
            }
          }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Contact/Contact.vue